module.exports = __webpack_public_path__ + "static/media/portfolio1.888281f8.png";